import $api from "@/api";
import {
  GoalEarnings,
  GoalTemplate,
  GoalWinner,
  PersonalGoalInitResponse,
} from "@/apps/goals/types";

export const requestPersonalGoalInit = async (yandexId: string) => {
  const { data } = await $api.get<PersonalGoalInitResponse>(
    "/personal-goal/init/",
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};

export const updatePersonalGoalRegionGroup = async (
  yandexId: string,
  regionGroupId: number
) => {
  const { data } = await $api.post<PersonalGoalInitResponse>(
    "/personal-goal/region-groups/",
    {
      region_group_id: regionGroupId,
    },
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};

export const requestPersonalGoalSpin = async (yandexId: string) => {
  const { data } = await $api.post<GoalTemplate>("/personal-goal/spin/", null, {
    params: {
      yandex_id: yandexId,
    },
  });

  return data;
};

export const requestLastPersonalGoalWinners = async (
  programConfigId: number
) => {
  const { data } = await $api.get<GoalWinner[]>(
    "/personal-goal/last-personal-goal-winners/",
    {
      params: {
        program_config_id: programConfigId,
      },
    }
  );

  return data;
};

export const requestPersonalGoalEarnings = async (yandexId: string) => {
  const { data } = await $api.get<GoalEarnings>("/personal-goal/earnings/", {
    params: {
      yandex_id: yandexId,
    },
  });

  return data;
};

export const requestPersonalGoalWithdraw = async (yandexId: string) => {
  const { data } = await $api.post("/personal-goal/withdraw/", null, {
    params: {
      yandex_id: yandexId,
    },
  });

  return data;
};

interface MultiplierSpinResponse {
  multiplier: number;
  base_reward: number;
  final_reward: number;
}

export const requestPersonalGoalMultiplierSpin = async (yandexId: string) => {
  const { data } = await $api.post<MultiplierSpinResponse>(
    "/personal-goal/multiplier-spin/",
    null,
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data.multiplier;
};
